"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataObjectTypeConfig = void 0;
var realmsEditor_model_1 = require("./realmsEditor.model");
function getDataObjectTypeConfig(type) {
    switch (type) {
        case realmsEditor_model_1.DataObjectType.Box: {
            return {
                canSetMaterial: true,
                canSetGeometry: true,
                canSetShapeProperties: true,
                canHaveChildren: true,
                bubblesClick: false,
            };
        }
        case realmsEditor_model_1.DataObjectType.Sphere: {
            return {
                canSetMaterial: true,
                canSetGeometry: true,
                canSetShapeProperties: true,
                canHaveChildren: true,
                bubblesClick: false,
            };
        }
        case realmsEditor_model_1.DataObjectType.Plane: {
            return {
                canSetMaterial: true,
                canSetGeometry: true,
                canSetShapeProperties: true,
                // Its set to false because THREEJS Planes are by default
                // vertical so we have to rotate 90 degrees meaning children
                // are also rotated 90 degrees. This is a hacky solution but
                // if solved properly please remove. However, for some reason,
                // this translates to a cannon es height field fine without rotation?
                canHaveChildren: false,
                bubblesClick: false,
            };
        }
        case realmsEditor_model_1.DataObjectType.Cylinder: {
            return {
                canSetMaterial: true,
                canSetGeometry: true,
                canSetShapeProperties: true,
                canHaveChildren: true,
                bubblesClick: false,
            };
        }
        case realmsEditor_model_1.DataObjectType.Group: {
            return {
                canSetMaterial: false,
                canSetGeometry: false,
                canSetShapeProperties: false,
                canHaveChildren: true,
                bubblesClick: false,
            };
        }
        case realmsEditor_model_1.DataObjectType.BlueprintRef: {
            return {
                canSetMaterial: false,
                canSetGeometry: false,
                canSetShapeProperties: false,
                canHaveChildren: false,
                bubblesClick: true,
            };
        }
        case realmsEditor_model_1.DataObjectType.HemisphereLight: {
            return {
                canSetMaterial: false,
                canSetGeometry: false,
                canSetShapeProperties: false,
                canHaveChildren: true,
                bubblesClick: true,
            };
        }
        case realmsEditor_model_1.DataObjectType.AmbientLight: {
            return {
                canSetMaterial: false,
                canSetGeometry: false,
                canSetShapeProperties: false,
                canHaveChildren: true,
                bubblesClick: true,
            };
        }
        case realmsEditor_model_1.DataObjectType.DirectionalLight: {
            return {
                canSetMaterial: false,
                canSetGeometry: false,
                canSetShapeProperties: false,
                canHaveChildren: true,
                bubblesClick: true,
            };
        }
        case realmsEditor_model_1.DataObjectType.PluginDataObject: {
            return {
                canSetMaterial: false,
                canSetGeometry: false,
                canSetShapeProperties: false,
                canHaveChildren: false,
                bubblesClick: true,
            };
        }
        case realmsEditor_model_1.DataObjectType.Sprite: {
            return {
                canSetMaterial: false,
                canSetGeometry: false,
                canSetShapeProperties: false,
                canHaveChildren: true,
                bubblesClick: false,
            };
        }
        case realmsEditor_model_1.DataObjectType.Asset3D: {
            return {
                canSetMaterial: false,
                canSetGeometry: false,
                canSetShapeProperties: false,
                canHaveChildren: false,
                bubblesClick: true,
            };
        }
    }
}
exports.getDataObjectTypeConfig = getDataObjectTypeConfig;
